import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8c1040c2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "complete-order-wrapper d-flex fl-s-b"
};
var _hoisted_2 = {
  class: "booking-left-side d-flex fl-col fl-s-b"
};
var _hoisted_3 = {
  key: 0,
  class: "mb-10"
};
var _hoisted_4 = {
  class: "d-block f-bold"
};
var _hoisted_5 = {
  key: 1,
  class: "mb-10"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "d-block f-bold"
  }, /*#__PURE__*/_toDisplayString("Promocode"
  /*$t("button.discount") */
  ))], -1);
});

var _hoisted_7 = {
  key: 2,
  class: "mb-10"
};
var _hoisted_8 = {
  key: 3,
  class: "mb-10"
};
var _hoisted_9 = {
  class: "booking-right-side d-flex fl-col"
};
var _hoisted_10 = {
  key: 0,
  class: "d-flex fl-col fl-j-c"
};
var _hoisted_11 = {
  class: "d-flex flex-row fl-j-c"
};
var _hoisted_12 = {
  class: "d-flex flex-row fl-j-c"
};
var _hoisted_13 = {
  class: "d-flex flex-row fl-j-c"
};
var _hoisted_14 = {
  key: 1
};
var _hoisted_15 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center"
  }
};
var _hoisted_16 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "flex-end",
    "height": "70px",
    "width": "50%"
  }
};
var _hoisted_17 = {
  style: {
    "font-size": "1.125rem"
  }
};
var _hoisted_18 = {
  key: 0,
  style: {
    "width": "50%",
    "height": "150px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "start",
    "justify-content": "end",
    "gap": "1rem"
  }
};
var _hoisted_19 = {
  class: "light-text"
};
var _hoisted_20 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "width": "100%"
  }
};
var _hoisted_21 = {
  class: "light-text"
};
var _hoisted_22 = {
  class: "light-text"
};
var _hoisted_23 = {
  key: 1
};
var _hoisted_24 = {
  key: 2
};
var _hoisted_25 = {
  key: 3
};
var _hoisted_26 = {
  key: 4
};
var _hoisted_27 = {
  key: 5
};
var _hoisted_28 = {
  key: 6
};
var _hoisted_29 = {
  key: 7
};
var _hoisted_30 = {
  key: 8
};
var _hoisted_31 = {
  key: 9
};
var _hoisted_32 = {
  key: 10
};
var _hoisted_33 = {
  key: 11
};
var _hoisted_34 = {
  key: 12
};
var _hoisted_35 = {
  key: 13
};
var _hoisted_36 = {
  key: 14
};
var _hoisted_37 = {
  key: 15
};
var _hoisted_38 = {
  key: 16
};
var _hoisted_39 = {
  key: 17
};
var _hoisted_40 = {
  key: 18
};
var _hoisted_41 = {
  key: 19
};
var _hoisted_42 = {
  key: 20
};
var _hoisted_43 = {
  key: 21
};
var _hoisted_44 = {
  key: 2
};
var _hoisted_45 = {
  key: 3
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$selectedCashCurr, _ctx$selectedCashCurr2;

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_radio_button = _resolveComponent("el-radio-button");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_row = _resolveComponent("el-row");

  var _component_Promocode = _resolveComponent("Promocode");

  var _component_Discount = _resolveComponent("Discount");

  var _component_PromocodeCampaigns = _resolveComponent("PromocodeCampaigns");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentSettings, function (paymentSetting) {
    return _openBlock(), _createElementBlock("div", {
      class: "mb-10",
      key: paymentSetting.id
    }, [_createVNode(_component_el_button, {
      type: "primary",
      class: _normalizeClass(["w-100 booking-button f-bold payment-option", {
        selected: _ctx.paymentTool === _ctx.PaymentMethodTypeToPaymentTool[paymentSetting.id] && _ctx.step === _ctx.BookingStep.Payment && !_ctx.isFree1,
        'disabled-payment-option': _ctx.disablePaymentTool(_ctx.PaymentMethodTypeToPaymentTool[paymentSetting.id]) || _ctx.step === _ctx.BookingStep.Refund
      }]),
      onClick: function onClick($event) {
        return _ctx.updatePaymentTool(paymentSetting.id, _ctx.PaymentMethodTypeToPaymentTool[paymentSetting.id]);
      },
      disabled: _ctx.disablePaymentTool(_ctx.PaymentMethodTypeToPaymentTool[paymentSetting.id]) || _ctx.isFree1 || _ctx.isFullyPaidInPromocodeStep || _ctx.isFullyPaidInDiscountStep || _ctx.step === _ctx.BookingStep.Refund
    }, {
      default: _withCtx(function () {
        return [_createTextVNode(_toDisplayString(_ctx.PaymentMethodTypeToTranslatedString[paymentSetting.id]), 1)];
      }),
      _: 2
    }, 1032, ["class", "onClick", "disabled"])]);
  }), 128)), _ctx.showDiscount
  /* && !IsEditOrder*/
  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_ctx.showDiscountButton ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    type: "primary",
    class: _normalizeClass(["w-100 booking-button payment-option", {
      selected: _ctx.step === _ctx.BookingStep.Discount,
      'disabled-payment-option': _ctx.disablePaymentTool(_ctx.PaymentTool.CardManual) || _ctx.step === _ctx.BookingStep.Refund
    }]),
    onClick: _ctx.displayDiscounts,
    disabled: _ctx.disablePaymentTool(_ctx.PaymentTool.CardManual) || _ctx.step === _ctx.BookingStep.Refund
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("button.discount")), 1)])];
    }),
    _: 1
  }, 8, ["class", "onClick", "disabled"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.step !== _ctx.BookingStep.Refund ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_button, {
    type: "primary",
    class: _normalizeClass(["w-100 booking-button payment-option", {
      selected: _ctx.step === _ctx.BookingStep.Promocode
    }]),
    onClick: _ctx.displayPromocodeArea
  }, {
    default: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  }, 8, ["class", "onClick"])])) : _createCommentVNode("", true), _ctx.step !== _ctx.BookingStep.Refund && _ctx.showPromocodeCampaignsButton ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_button, {
    type: "primary",
    class: _normalizeClass(["w-100 booking-button f-bold payment-option", {
      selected: _ctx.step === _ctx.BookingStep.PromocodeCampaigns
    }]),
    onClick: _ctx.displayPromocodeCampaigns
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", null, _toDisplayString(_ctx.$t("button.promocode-campaigns")), 1)];
    }),
    _: 1
  }, 8, ["class", "onClick"])])) : _createCommentVNode("", true), _ctx.step === _ctx.BookingStep.Refund ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_button, {
    type: "primary",
    class: "w-100 booking-button f-bold payment-option selected-warning"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.refund")), 1)];
    }),
    _: 1
  })])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_9, [_ctx.step === _ctx.BookingStep.Refund ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    class: "order-amount default-cursor"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.whatIsLeftToPayText), 1)];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_select, {
    modelValue: _ctx.refundPaymentMethod,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.refundPaymentMethod = $event;
    })
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.refundPaymentMethodOptions, function (paymentSetting) {
        return _openBlock(), _createBlock(_component_el_option, {
          class: "refund-option",
          key: paymentSetting.id,
          label: _ctx.PaymentMethodTypeToTranslatedString[paymentSetting.id],
          value: paymentSetting.id,
          disabled: _ctx.isRefundPaymentMethodDisabled(paymentSetting)
        }, null, 8, ["label", "value", "disabled"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
    size: "large",
    class: "apply-btn",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.handleRefund(_ctx.restToPay);
    })
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.apply")), 1)];
    }),
    _: 1
  })])])) : _ctx.step !== _ctx.BookingStep.Discount && _ctx.step !== _ctx.BookingStep.Promocode && _ctx.step !== _ctx.BookingStep.PromocodeCampaigns && !_ctx.isFree1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_ctx.paymentTool === _ctx.PaymentTool.Cash ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("multicurrencies.cash-payment")), 1)]), _createElementVNode("div", null, [_ctx.currencies.length > 1 && _ctx.hasMultiCurrenciesEnabled ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "other-currencies-btn",
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    function () {
      return _ctx.toggleMultiCurrencies && _ctx.toggleMultiCurrencies.apply(_ctx, arguments);
    })
  }, _toDisplayString(_ctx.payInMultiCurrencies ? "".concat(_ctx.$t("multicurrencies.pay-in"), " ").concat(_ctx.bookingPaymentCurrency) : _ctx.$t("multicurrencies.pay-in-other-currencies")), 1)) : _createCommentVNode("", true)])]), _createVNode(_component_el_divider, {
    style: {
      "width": "50%",
      "border": "1px solid rgba(0, 0, 0, 0.15)"
    }
  }), _ctx.payInMultiCurrencies ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("multicurrencies.currency-of-payment")), 1)]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_radio_group, {
    size: "large",
    onChange: _ctx.selectedCashCurrencyChanged,
    "model-value": _ctx.selectedCashCurrencyLabel
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies.filter(function (c) {
        return c.label !== _ctx.bookingPaymentCurrency;
      }), function (currency) {
        return _openBlock(), _createBlock(_component_el_radio_button, {
          key: currency.id,
          label: currency.label
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(currency.label), 1)];
          }),
          _: 2
        }, 1032, ["label"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["onChange", "model-value"])]), _createElementVNode("div", {
    style: _normalizeStyle([{
      visibility: _ctx.selectedCashCurrency ? 'visible' : 'hidden'
    }, {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "end",
      "width": "100%",
      "height": "50px"
    }])
  }, [_createElementVNode("div", null, [_createElementVNode("p", _hoisted_21, " 1 " + _toDisplayString(_ctx.groupCurrency.label) + " = " + _toDisplayString((_ctx$selectedCashCurr = _ctx.selectedCashCurrency) === null || _ctx$selectedCashCurr === void 0 ? void 0 : _ctx$selectedCashCurr.exchangeRate) + " " + _toDisplayString((_ctx$selectedCashCurr2 = _ctx.selectedCashCurrency) === null || _ctx$selectedCashCurr2 === void 0 ? void 0 : _ctx$selectedCashCurr2.label), 1)]), _createElementVNode("div", null, [_createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.displayedAmount), 1)])], 4)])) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    style: {
      "width": "100%"
    },
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay ? '' : 'default-cursor']),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.whatIsLeftToPay ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  }), _createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: "amount-button",
        onClick: _ctx.showCalculator
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.custom")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        class: "amount-button",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return _ctx.updateEnteredAmount(_ctx.whatIsLeftToPay / 100);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.whatIsLeftToPayText), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "amount-button",
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return _ctx.updateEnteredAmount(10);
        })
      }, {
        default: _withCtx(function () {
          var _ctx$selectedCashCurr3;

          return [_createTextVNode(_toDisplayString((((_ctx$selectedCashCurr3 = _ctx.selectedCashCurrency) === null || _ctx$selectedCashCurr3 === void 0 ? void 0 : _ctx$selectedCashCurr3.label) || _ctx.paymentCurrency) + " " + 10), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: "amount-button",
        onClick: _cache[6] || (_cache[6] = function ($event) {
          return _ctx.updateEnteredAmount(20);
        })
      }, {
        default: _withCtx(function () {
          var _ctx$selectedCashCurr4;

          return [_createTextVNode(_toDisplayString((((_ctx$selectedCashCurr4 = _ctx.selectedCashCurrency) === null || _ctx$selectedCashCurr4 === void 0 ? void 0 : _ctx$selectedCashCurr4.label) || _ctx.paymentCurrency) + " " + 20), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "amount-button",
        onClick: _cache[7] || (_cache[7] = function ($event) {
          return _ctx.updateEnteredAmount(50);
        })
      }, {
        default: _withCtx(function () {
          var _ctx$selectedCashCurr5;

          return [_createTextVNode(_toDisplayString((((_ctx$selectedCashCurr5 = _ctx.selectedCashCurrency) === null || _ctx$selectedCashCurr5 === void 0 ? void 0 : _ctx$selectedCashCurr5.label) || _ctx.paymentCurrency) + " " + 50), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "amount-button",
        onClick: _cache[8] || (_cache[8] = function ($event) {
          return _ctx.updateEnteredAmount(100);
        })
      }, {
        default: _withCtx(function () {
          var _ctx$selectedCashCurr6;

          return [_createTextVNode(_toDisplayString((((_ctx$selectedCashCurr6 = _ctx.selectedCashCurrency) === null || _ctx$selectedCashCurr6 === void 0 ? void 0 : _ctx$selectedCashCurr6.label) || _ctx.paymentCurrency) + " " + 100), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.CardAuto ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[9] || (_cache[9] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.BankTransfer ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.Invoice ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.ToBeInvoiced ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[12] || (_cache[12] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.CardManual ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[13] || (_cache[13] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.Cheque ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[14] || (_cache[14] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.ChequeVacances ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[15] || (_cache[15] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.ChequeCulture ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[16] || (_cache[16] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.PassCulture ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[17] || (_cache[17] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.Chorus ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[18] || (_cache[18] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.CE ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[19] || (_cache[19] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.OCCYG ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[20] || (_cache[20] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.CouponSport ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[21] || (_cache[21] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.PosReka ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[22] || (_cache[22] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.DiverseVoucher ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[23] || (_cache[23] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.CFF ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[24] || (_cache[24] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.CGN ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[25] || (_cache[25] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.QOQA ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[26] || (_cache[26] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.DEINDEAL ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[27] || (_cache[27] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : _ctx.paymentTool === _ctx.PaymentTool.REALDEAL ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_button, {
        class: _normalizeClass(['order-amount', _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? '' : 'default-cursor']),
        onClick: _cache[28] || (_cache[28] = function ($event) {
          return _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? _ctx.showCalculator() : null;
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.displayedAmount) + " ", 1), _ctx.whatIsLeftToPay && _ctx.doesSupportSplitPayment ? (_openBlock(), _createBlock(_component_SvgIcon, {
            key: 0,
            iconContent: _ctx.iconContent,
            iconAlt: _ctx.iconAlt,
            iconStyle: _ctx.iconStyle
          }, null, 8, ["iconContent", "iconAlt", "iconStyle"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["class"])];
    }),
    _: 1
  })])) : (_openBlock(), _createElementBlock("div", _hoisted_43, [_createVNode(_component_el_row, {
    justify: "center"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("p", null, _toDisplayString(_ctx.$t("payment.no-payment-method")), 1)];
    }),
    _: 1
  })]))])) : _ctx.step === _ctx.BookingStep.Promocode ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createVNode(_component_Promocode)])) : _ctx.step === _ctx.BookingStep.Discount ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createVNode(_component_Discount)])) : _ctx.step === _ctx.BookingStep.PromocodeCampaigns ? (_openBlock(), _createBlock(_component_PromocodeCampaigns, {
    key: 4
  })) : _createCommentVNode("", true)])]);
}